/**
 * Move V2 Redux slice
 *
 * Owns the shared loading flag for the move flow. The location-contents fetch,
 * source/destination resolution, and move thunks flip it; the lightweight
 * origin validation intentionally does not (it backs an inline scan input).
 */
import { createSlice } from '@reduxjs/toolkit';
import { fetchMoveLocationContents, performMove, resolveMoveDestination, resolveMoveSource } from './moveThunks';
var initialState = {
    isLoading: false
};
export var moveSlice = createSlice({
    name: 'move',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        var tracked = [fetchMoveLocationContents, resolveMoveSource, resolveMoveDestination, performMove];
        tracked.forEach(function (thunk) {
            builder
                .addCase(thunk.pending, function (state) {
                state.isLoading = true;
            })
                .addCase(thunk.fulfilled, function (state) {
                state.isLoading = false;
            })
                .addCase(thunk.rejected, function (state) {
                state.isLoading = false;
            });
        });
    }
});
export default moveSlice.reducer;
